import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { Graph } from './graph';
const graph = new Graph();
export function ForceDirectedGraph(param) {
    let { data, config, extraConfig, onNodeSelect } = param;
    const [firstInit, setFirstInit] = useState(true);
    const nodeGraphContainerRef = useRef(null);
    useEffect(()=>{
        if (!config || !firstInit || !nodeGraphContainerRef.current) {
            return;
        }
        setFirstInit(false);
        graph.simulate(nodeGraphContainerRef.current, data, config);
        graph.onNodeSelect = onNodeSelect;
    }, [
        config,
        data,
        firstInit,
        onNodeSelect
    ]);
    useEffect(()=>{
        if (config) {
            graph.updateSize(config);
        }
        if (extraConfig) {
            graph.setLevel(extraConfig.nodeDepth);
            graph.setLineThickness(extraConfig.linesThickness);
            graph.setDirection(extraConfig.direction);
            // extraConfig.selectedNode is from NodeGraphFilter and has a different GraphNode type
            // We need to cast it to our GraphNode type
            if (extraConfig.selectedNode) {
                graph.setSelectedNode(extraConfig.selectedNode);
            }
        }
    }, [
        extraConfig,
        config
    ]);
    return /*#__PURE__*/ _jsx("div", {
        id: "graph",
        ref: nodeGraphContainerRef,
        className: "force-directed-graph h-full w-full overflow-hidden",
        style: {
            '--node-color': 'hsl(var(--muted-foreground))',
            '--node-active-color': 'hsl(var(--primary))',
            '--link-color': 'hsl(var(--border))',
            '--link-active-color': 'hsl(var(--primary))',
            '--label-color': 'hsl(var(--muted-foreground))',
            '--label-active-color': 'hsl(var(--foreground))',
            '--marker-color': 'hsl(var(--border))',
            '--marker-active-color': 'hsl(var(--primary))'
        },
        children: /*#__PURE__*/ _jsx("style", {
            children: "\n        #graph {\n          position: relative;\n          width: 100%;\n          height: 100%;\n        }\n        #graph svg {\n          width: 100%;\n          height: 100%;\n          max-width: 100%;\n          max-height: 100%;\n          display: block;\n        }\n      "
        })
    });
}
